module.exports = __webpack_public_path__ + "6c251cc72c679faec4d987ab12c7b4e8.svg";